import { render, staticRenderFns } from "./tableAllowance.vue?vue&type=template&id=b3427c74&"
import script from "./tableAllowance.vue?vue&type=script&lang=js&"
export * from "./tableAllowance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports